/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// Per-environment values are set on window.__env by /env.js, which is served from the
// gfs-ui-env ConfigMap (see .pipeline/manifest.k8.*.yml) and must load before the app bundles.
const runtimeEnv: Record<string, string> = (window as unknown as { __env?: Record<string, string> }).__env ?? {};

export const environment = {
  production: true,
  appName: 'Global Forecast System',
  appVersion: '8.2.0',
  appVersionCodename: 'v8.2.0',
  baseApiUrl: runtimeEnv.baseApiUrl,
  buildNumber: '0',
  environmentName: runtimeEnv.environmentName,
  apiMap: {},
  appLauncherUrls: {
    repo: 'https://link.gm.com/fabric-starter-repo'
  },
  auth: {
    issuer: `https://login.microsoftonline.com/${runtimeEnv.tenantId}/v2.0`,
    clientId: runtimeEnv.clientId,
    redirectUri: location.origin,
    responseType: 'code',
    scope: `openid profile email offline_access ${runtimeEnv.clientId}/.default`,
    showDebugInformation: true,
    // turn off validation that discovery document endpoints start with the issuer url defined above
    strictDiscoveryDocumentValidation: false
  },
  message: 'Hello, localhost!'
};
